/**
 * @description Gère la masonry des numbers
 */

(() => {
	const root = document.querySelectorAll('.key-numbers__list');
	const masonry = () => {
		root.forEach((block) => {
			const numberCount = block.children.length;
			const getnumbers = block.querySelectorAll('li');
			if (numberCount === 1) {
				getnumbers.forEach((number) => {
					number.classList.add('card--centered');
				});
			}
			if (numberCount > 2) {
				block
					.querySelectorAll('.key-numbers__list>li:nth-child(even)')
					.forEach((numberEven) => {
						numberEven.classList.add('card--transformed');
					});
				block
					.querySelectorAll('.key-numbers__list>li:nth-child(odd)')
					.forEach((numberEven) => {
						numberEven.classList.add('card--mb-1');
					});
			}
		});
	};

	// GO 🚀
	const init = () => {
		masonry();
	};

	init();
})();
